export default __webpack_public_path__ + "assets/img/no-image.161fcce85c949fe3d7ee8bf5ecfdc270.jpg";